
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { COUNTRIES } from '../utils/countries'

@Component({
  inheritAttrs: false,
})
export default class FlagSelect extends Vue {
  @Prop({ required: true }) readonly country!: string

  private currentCountry = this.country

  @Watch('currentCountry')
  onCountryChanged(val = '') {
    this.$emit('change', val)
  }

  private readonly countries = COUNTRIES
}
